import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  school: belongsTo(),
  schoolClasses: hasMany(),
})
